import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

export default function (Component) {
	Component.propTypes = Component.propTypes || {};
	Component.propTypes.backPath =
		Component.propTypes.backPath || PropTypes.string.isRequired;

	return withRouter(
		connect(
			(state, ownProps) => ({
				goBackTo: (e) => {
					if (e && e.preventDefault) {
						e.preventDefault();
					}

					if (
						state.app.previousLocation &&
						state.app.previousLocation.pathname === ownProps.backPath
					) {
						ownProps.history.goBack();
					} else {
						ownProps.history.push(ownProps.backPath);
					}
				},
			}),
		)(Component)
	);
}
